module.exports = __webpack_public_path__ + "h5/img/huodong_2.b11d53b5.jpg";